// extracted by mini-css-extract-plugin
module.exports = {"barContainer":"BarChart_barContainer__20mgy"};